import * as React from "react";

export type LiveCodingAudioSpeakerProps = {
  id: string;
  audioTrack?: MediaStreamTrack;
};

const LiveCodingAudioSpeaker: React.FC<LiveCodingAudioSpeakerProps> = props => {
  const ref = React.useRef<HTMLAudioElement>(null);

  React.useEffect(() => {
    if (!props.audioTrack || !ref.current) {
      return;
    }
    const el = ref.current;
    el.srcObject = new MediaStream([props.audioTrack]);
    el.play();

    return () => {
      el.pause();
      el.src = "";
      el.srcObject = null;
    };
  }, [props.audioTrack]);

  if (!props.audioTrack) {
    return null;
  }

  return <audio id={props.id} ref={ref} autoPlay />;
};

LiveCodingAudioSpeaker.displayName = "LiveCodingAudioSpeaker";

export default LiveCodingAudioSpeaker;
